import { styled } from 'linaria/react';

export const MeasurementBannerContainer = styled.div`
  display: flex;
  flex-direction: column;
  gap: var(--space-200);
  width: 29%;
  height: fit-content;
  padding: var(--space-300);
  margin-top: var(--space-300);
  background: var(--service-light);
  border-radius: 5px;

  @media (--only-mobile) {
    width: 100%;
    padding: var(--space-200);
    margin-top: 0;
  }
`;
